<template>
    <div>
		<template v-if="!isEditMode" >
			<page-sub-title :title="'eventClassDef'" :info="''"></page-sub-title>
			<v-row><v-col>
				<v-select outlined dense
				hide-details="auto"
				v-model="defBaseSelected"
				:items="defBaseDD"
				@change="onSelectorChanged">
				</v-select>
			</v-col></v-row>
			<v-row v-if="isDefBaseCopy && !presetLoading && anyPreset"><v-col>
				<v-autocomplete outlined dense
					hide-details="auto"
					:readonly="hasOnlyOnePreset"
					v-model="presetBestlist.selected"
					:items="presetBestlist.items"
					:label="$t('text.bestlistTitle')"
					@input="$v.presetBestlist.selected.$touch()"
					@blur="$v.presetBestlist.selected.$touch()"
					@change="onPresetSelected"
					:loading="presetLoading">
				</v-autocomplete>
			</v-col></v-row>
		</template>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { required } from 'vuelidate/lib/validators';

import bestListActions from '../store/actions/bestList';
import namespace from '../store/namespace';

import PageSubTitle from '../general/PageSubTitle.vue';

import getDefinitionPresets from '../models/definitionPresets';


export default {
	name: 'CustomDefBase',
	components: {
		PageSubTitle,
	},
	validations: {
		presetBestlist: {
			selected: {
				required,
			},
		},
	},
	data() {
		return {
			presetLoading: false,
			presetBestlist: {
				items: [],
				selected: null,
			},
			id: this.$route.params.id || null,
			defBaseSelected: 0,

		};
	},
	mounted() {
		this.getPresetList();
		this.defBaseSelected = this.isEditMode ? 2 : 0;
		this.emitSelectionReturn(true);
	},
	computed: {
		...mapGetters(namespace.ORGANIZATION, ['ExternalId']),
		hasOnlyOnePreset() {
			return this.presetBestlist.items.length === 1;
		},
		defBaseDD() {
			return getDefinitionPresets(this);
		},
		anyPreset() {
			return this.presetBestlist.items.length > 0;
		},
		isEditMode() {
			return !!this.id;
		},
		isDefBaseCopy() {
			return this.defBaseSelected === 1;
		},
		isBestListSelected() {
			return (this.presetBestlist.selected != null);
		},
	},
	methods: {
		...mapActions(namespace.BESTLIST, [
			bestListActions.GET_BEST_LISTS_FOR_SELECTOR,
		]),
		onSelectorChanged() {
			this.emitSelectionReturn((!this.isDefBaseCopy || this.isBestListSelected));
		},
		onPresetSelected() {
			this.emitSelectionReturn(this.isBestListSelected);
		},
		async getPresetList() {
			this.presetLoading = true;
			try {
				const items = await this.GET_BEST_LISTS_FOR_SELECTOR(this.ExternalId);
				if (items && this.isEditMode) {
					this.presetBestlist.items = items.filter(x => x.value !== this.id);
				} else {
					this.presetBestlist.items = items;
				}
				this.presetBestlist.selected = this.presetBestlist.items[0].value;
			} finally {
				this.presetLoading = false;
			}
		},
		emitSelectionReturn(valide) {
			this.$emit('onPresetSelected', { valide, selectedPreset: this.presetBestlist.selected, selectedDefBase: this.defBaseSelected });
		},
	},
};
</script>
